import React, {useContext} from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { WebSettingsContext } from "@providers/WebsettingsProvider";
import { useSelector, useDispatch } from "react-redux";


const WebLinks: React.FC<{ webLinks: [] }> = (props) => {
 
  const { t, i18n } = useTranslation();

  if (props?.webLinks?.length > 0) {
    return (
      <div className='BootstrapMulti'>
      <Section className="section-content padding-y ">
      {props?.webLinks?.length > 0 ? (
        <div className="container">
            <Header>
              <p>{t("CON_LINKS")}</p>
            </Header>      
          
          <GridContainer>
            <UList>
              {props?.webLinks?.map((product: any) => {
                return (
                    <List>
                      <a href={product?.linkAddress} target="_blank">
                        <Code >{product?.linkDescription}</Code>
                      </a>
                    </List>
                                
                );
              })}
            </UList>
         </GridContainer>
        
        </div>
      ) : (
        " "
      )}
      
    </Section>
    </div>
    );
  } else {
    return <></>;
  }
};

export default WebLinks;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  align-items: center;
  margin-bottom: 10px;
  > p {
    font-size: calc(var(--base-font-size) + 10px);
    font-weight: var(--font-weight-bold);
  }
  
`;

const GridContainer = styled.div`
  display: grid;
  gap: 0px;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  @media (min-width: 1450px) {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
  @media (max-width: 750px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  @media (max-width: 600px) {
    gap: 0px;
  }
`;

const Code = styled.a`
  color: var(--primary-color-2) ;
  opacity: var(--medium-opacity);
`;

const List = styled.li`
  padding-left: 10px;
`;

const UList = styled.ul`
  
`;

const Section = styled.section`
  margin-left: 25px;
  margin-right: 25px;
`;
